import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import * as types from 'store/actions/types';

function* paymentSlipOrderFailureAsync({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

function* paymentSlipOrderSuccessAsync({ message }) {
    yield put(showNotification(message, 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    yield put(showNotification(message, 'warning'));
}

export default function* paymentSlipSagas() {
    yield [
        takeEvery(types.PAYMENT_SLIP_DOWNLOAD_FAILURE, failureMessage),

        takeEvery(types.PAYMENT_SLIP_ORDER_FAILURE, paymentSlipOrderFailureAsync),
        takeEvery(types.PAYMENT_SLIP_ORDER_SUCCESS, paymentSlipOrderSuccessAsync),
    ];
}


// WEBPACK FOOTER //
// ./src/store/sagas/paymentSlipSagas.js